import angular from 'angular';
import template from './quality-menu.html';
import _ from 'lodash';
import { VideoQuality } from '../../../modules/call/constants';
class Controller {
    constructor($rootScope, $translate, currentUserHelper, VideoQualityService, User) {
        this.$translate = $translate;
        this.currentUserHelper = currentUserHelper;
        this.VideoQualityService = VideoQualityService;
        this.User = User;
        this.isActive = false;
        this.setDefaultText();
        this.isPaidUser = this.currentUserHelper.canUsePaidFeatures();
    }
    setDefaultText() {
        this.text = _.cloneDeep(this.VideoQualityService.options);
    }
    isSelected(quality) {
        return this.VideoQualityService.current === quality;
    }
    checkQuality(quality) {
        if (!this.isPaidUser) {
            if (quality === VideoQuality.Medium) {
                this.text.sd = this.$translate.instant('video-chat.message.upgrade', {
                    quality,
                });
            }
            else if (quality === VideoQuality.High) {
                this.text.hd = this.$translate.instant('video-chat.message.upgrade', {
                    quality,
                });
            }
        }
    }
    changeQuality(quality) {
        if (!this.currentUserHelper.canUsePaidFeatures()) {
            return;
        }
        this.User.prototype$updateAttributes({ id: this.User.getCurrentId() }, { videoQuality: quality });
        this.VideoQualityService.switchTo(quality);
    }
    hide() {
        if (this.isActive) {
            this.setDefaultText();
            this.isActive = false;
        }
    }
}
const component = {
    template,
    bindings: {
        isActive: '=',
        isPatient: '<',
    },
    controller: Controller,
};
export default angular
    .module('doxy.videoChat.callActions.callActionsQualityMenu', [])
    .component('callActionsQualityMenu', component).name;
